import { extractJobTitleFromURL, readCookie } from '@components/common';
import {
  createErrorContent,
  createSearchURL,
  getCommonText,
} from '@components/common/constant';
import { JobLinks, socialLinks } from '@components/wlb/constant';
import { ErrorPage, useDeviceType } from '@license-admin/boldjobs';
import errorPageProps from '@utils/errorPageProps';
import { useEffect, useState } from 'react';

interface ErrorPageProps {
  statusCode: number;
  fromPage?: string;
  themeType?: string;
}
const extractCategoryFromUrl = (url: string) => {
  // Handle empty URL
  if (!url) return null;

  // Create URL object for easier parsing
  try {
    const urlObj = new URL(url);
    const path = urlObj.pathname;

    // Check if this is a category page
    if (path.startsWith('/remote-jobs/')) {
      // Extract the category slug (everything after /remote-jobs/)
      const categorySlug = path.replace('/remote-jobs/', '').split('/')[0];

      // Only return if we have a valid category
      if (categorySlug && categorySlug.length > 0) {
        return {
          categorySlug,
          isCategory: true,
          fullPath: path,
          searchParams: urlObj.search,
        };
      }
    }
  } catch (e) {
    console.error('Error parsing URL:', e);
  }

  return null;
};
const ErrorPageWrap: React.FC<ErrorPageProps> = ({
  statusCode,
  fromPage,
  themeType,
}) => {
  const isDesktopView = useDeviceType() === 'desktop';
  const [currentURL, setCurrentURL] = useState<string>('');
  const [isSearchPage, setIsSearchPage] = useState<boolean>(false);
  const [IsCategoryPage, setIsCategoryPage] = useState<any>(null);
  const [jobTitle, setJobTitle] = useState<string>('');
  // const getCookies = readCookie('lastVisitedJobPage');
  // const actualFromPage = document.referrer || fromPage || 'Unknown source';
  const commonText = getCommonText('/contact');
  useEffect(() => {
    if (typeof window !== 'undefined') {
      const currentUrl = window.location.pathname + window.location.search;
      setIsSearchPage(currentUrl.includes('/search'));

      const isCategoryPages = extractCategoryFromUrl(window.location.href);
      setIsCategoryPage(isCategoryPages);
      // Store current page details
      setCurrentURL(currentUrl);

      // Extract job title from URL if it's a job details page
      const extractedTitle = extractJobTitleFromURL(currentUrl);
      setJobTitle(extractedTitle);
    }
  }, []);
  const searachURL = createSearchURL(jobTitle);
  const IsCategoriesPage = IsCategoryPage?.isCategory;
  // Get error content from constants file
  const errorContent = createErrorContent(
    commonText,
    searachURL,
    isSearchPage,
    IsCategoriesPage
  );

  const content = errorContent[statusCode as keyof typeof errorContent] || {
    ...errorContent.default,
    heading: `${errorContent.default.heading}`.replace(
      '{0}',
      statusCode.toString()
    ),
    message: `${errorContent.default.message}`.replace('{0}', commonText),
  };

  const isNotSubheading = content.subHeading === '';
  const errorPageProp = errorPageProps({
    statusCode: statusCode,
    heading: content.heading,
    subHeading: content.subHeading,
    message: content.message,
    subText: content.subText,
    jobLinks: JobLinks,
    socialLinks: socialLinks,
    isNotSubheading: isNotSubheading,
    themeType: themeType || 'graphite',
    btnText: content.btnText,
    btnUrl: content.btnUrl,
    isDesktopView: isDesktopView,
  });

  return <ErrorPage {...errorPageProp} />;
};

export default ErrorPageWrap;
